import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=7b071b1a&"
import script from "./TermsAndConditions.vue?vue&type=script&lang=ts&"
export * from "./TermsAndConditions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports